<template>
    <div>
        <div>
            <div style="float: right;">
                错误类型：
                <el-select v-model="type">
                    <el-option
                            v-for="item of typeOptions"
                            :key="item.label"
                            :value="item.value"
                            :label="item.label"/>
                </el-select>
              <el-button type="primary" @click="getList(type)">搜索</el-button>
            </div>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="this.form.errList"
                    :row-key="(row)=>row.id"
                    height="100%">
                <el-table-column label="错误id" min-width="150" align="center" prop="errId"/>
                <el-table-column label="错误的类型" min-width="150" align="center" prop="errType">
                  <template slot-scope="scope">{{statusType(scope.row.errType)}}</template>
                </el-table-column>
                <el-table-column label="错误的时间" min-width="150" align="center" prop="createTime">
                  <template slot-scope="scope">{{getLocalTime(scope.row.createTime)}}</template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="removeItem(scope.row.errId)">发送</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                show: false,
                currentPage: 1,
                type: '',
                typeOptions: [// 客户端类型
                    {
                        label: '全部',
                        value: null
                    },
                    {
                        label: '业绩分成错误',
                        value: 0
                    }
                ],
                form: {
                  errType: null,// 错误类型
                  errList:[]
                },
            }
        },
        computed: {
        },
        created() {
            this.getList(this.form.errType)
        },
        methods: {
            ...mapActions('product', ['getRestartCalculatorList', 'getRestartCalculator']),

            getList(type) {
                this.loading = true;
                console.log(type);
                this.getRestartCalculatorList({
                  errType:type
                }).then(res => {
                    this.form.errList=res.data;
                    this.loading = false;
                })
            },
            getLocalTime(nS) {
              return new Date(parseInt(nS)).toLocaleString().replace(/:\d{1,2}$/,' ');
            },
            statusType(status) {
              switch (status) {
                case 0:
                  status = '业绩计算';
                  break;
                default:
                  break;
              }
              return status;
            },
            removeItem(id) {
                this.loading = true;
                console.log(id);
                this.getRestartCalculator(id).then(() => {
                    this.$message.success('发送成功');
                    this.getList(this.form.errType);
                })
            },
        }
    }
</script>